import styled from '@emotion/styled';
import { theme } from '@pairy/styles';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const ShellRoot = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  height: var(--doc-height, 100dvh);
  flex-direction: column;
  background: ${theme.colors.zinc_100};
`;

/* 데스크톱: 좌측 페이지 목록(풀 높이) + 우측 툴바/슬라이드 컬럼 */
export const LayoutRow = styled.div`
  display: flex;
  width: 100%;
  min-height: 0;
  flex: 1;
`;

export const MainColumn = styled.div`
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 0;
  flex: 1;
  flex-direction: column;
`;

/* 페이지 목록이 닫혔을 때 좌측 엣지 세로 중앙에 붙는 열기 핸들 */
export const PanelEdgeHandle = styled.button`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.desktopLayer};
  top: 50%;
  left: 0;
  display: flex;
  width: 28px;
  height: 96px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.colors.zinc_300};
  border-left: none;
  background: ${theme.colors.white};
  border-radius: 0 10px 10px 0;
  box-shadow: ${theme.elevation.md};
  cursor: pointer;
  transform: translateY(-50%);
  transition: 0.15s ease-in-out;

  &:hover {
    width: 32px;
    background: ${theme.colors.zinc_100};
  }

  /* 다른 플로팅 컨트롤과 동일한 헬퍼 흐림 처리 */
  &.disabled {
    cursor: initial;
    opacity: 0.25;
  }
`;

/* 모바일: 상단 프로그레스 바(3px, fixed) 아래 문서 제목 영역 */
export const MobileTitleBar = styled.div`
  flex-shrink: 0;
  padding: 11px 16px 8px;
  border-bottom: 1px solid ${theme.colors.zinc_200};
  background: ${theme.colors.white};
`;

export const MobileTitle = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100vw - 60px);
`;

export const Body = styled.div<{ isMobile: boolean }>`
  display: flex;
  width: 100%;
  min-height: 0;
  flex: 1;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
`;

export const ContentWrapper = styled.div`
  position: relative;
  min-width: 0;
  min-height: 0;
  flex: 1;
`;
